import { apiClient } from '@/lib/api/client';
import { API_ENDPOINTS } from '@/lib/api/config';
import type { PaginatedResponse } from '@/lib/api/types';

import type {
  CreateStorageLocationRequest,
  StorageLocation,
  StorageLocationStats,
  StorageLocationsListParams,
  UpdateStorageLocationRequest
} from '../types';

const { STORAGE_LOCATIONS } = API_ENDPOINTS;

export const storageLocationsApi = {
  getAll: (params?: StorageLocationsListParams) =>
    apiClient.getPaginated<StorageLocation>(STORAGE_LOCATIONS.LIST, params),

  getById: (id: number) =>
    apiClient.get<PaginatedResponse<StorageLocation>>(
      STORAGE_LOCATIONS.GET(id)
    ),

  create: (data: CreateStorageLocationRequest) =>
    apiClient.post<StorageLocation>(STORAGE_LOCATIONS.CREATE, data),

  update: (id: number, data: UpdateStorageLocationRequest) =>
    apiClient.put<StorageLocation>(STORAGE_LOCATIONS.UPDATE(id), data),

  delete: (id: number, force = false) =>
    apiClient.delete(STORAGE_LOCATIONS.DELETE(id), { params: { force } }),

  getStats: () => apiClient.get<StorageLocationStats>(STORAGE_LOCATIONS.STATS),

  checkCode: (code: string, excludeId?: number) =>
    apiClient.get<{ unique: boolean }>(STORAGE_LOCATIONS.CHECK_CODE, {
      params: { code, exclude_id: excludeId }
    })
};
